module.exports = "<svg data-name=\"Layer 1\" viewBox=\"0 0 20 20\"><path d=\"M16.32 17.476l-1.734 1.025a3.577 3.577 0 0 1-4.913-1.28v-.001L3.746 7.09A3.619 3.619 0 0 1 5.02 2.15h.001l1.735-1.027a.882.882 0 0 1 1.21.315l.001.001 2.387 4.088a.892.892 0 0 1-.312 1.218h-.001L7.752 8.098l2.989 5.11 2.287-1.353a.882.882 0 0 1 1.211.315v.001l2.388 4.088a.894.894 0 0 1-.307 1.217z\" data-name=\"Path 6\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/phone.svg
// module id = 249
// module chunks = 1